import { StoryToPlayFragment } from '@graphql/generated/graphql';

import { StoryPageType } from '../enums';
import { SanitizedStoryPage } from '../types';
import { getMediaType } from './getMediaType';

type GetSanitizedStoryPagesOptions = {
    withTitle: boolean;
    muted: boolean;
};

export const getSanitizedStoryPages = (
    story: StoryToPlayFragment,
    options?: GetSanitizedStoryPagesOptions
): SanitizedStoryPage[] => {
    const { withTitle = true, muted = true } = options ?? {};
    if (!story.StoryPages) return [];

    return [...story.StoryPages]
        .sort((a, b) => {
            if (typeof a.Order === 'number' && typeof b.Order === 'number') {
                return a.Order - b.Order;
            }

            return parseInt(a.id) - parseInt(b.id);
        })
        .map((page) => ({
            type: getMediaType(page.Media!) as StoryPageType,
            ...(withTitle && { title: story.Title }),
            subtitle: page.Title,
            media: page.Media!,
            looping: page.Looping ?? false,
            muted,
            text: page.DisplayText,
            ...(page.CallToAction?.length && { ctas: page.CallToAction }),
        }));
};
